import { EventType } from './event-type.interface';

export const FIREPLACE: EventType = {
  name: 'Fireplace',
  description: 'When a Fireplace is lit or extinguished',
  route: 'fireplace',
  category: 'Fireplace',
  icon: 'fireplace',
  whitelist: [
    {
      proxy: 'relaysingle_gasfireplace_c4',
      events: [1, 2]
    },
    {
      proxy: 'fireplace',
      events: [1, 2]
    }
  ]
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-simple/event-types/fireplace.type.ts